<script setup>
import { ref, computed, onMounted } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";

const storeRequests = useRequestsStore();

const finalists = ref([]);
const winner = ref({});

const isWinner = computed(() => Object.keys(winner.value).length);

onMounted(async () => {
	finalists.value = await storeRequests.finalists();
	winner.value = await storeRequests.winner();
});
</script>
<template>
	<section class="finalists" id="finalists" v-if="finalists.length">
		<div class="container">
			<h2 class="finalists__title title2 --red">Финалисты</h2>
			<ul class="finalists__list">
				<li class="finalists__item" v-if="isWinner">
					<div class="finalists__holder-image">
						<div class="finalists__image">
							<img
								class="full-img"
								width="139"
								height="139"
								:src="winner.survey.photo"
								alt="изображение"
							/>
						</div>
						<div class="finalists__label --red">Победитель</div>
					</div>
					<div class="finalists__content">
						<h3 class="finalists__name">{{ winner.first_name }}</h3>
						<div class="finalists__info">
							<p class="finalists__city">{{ winner.survey.city }}</p>
							<p class="finalists__restaurant">{{ winner.survey.restaurant }}</p>
						</div>
						<p class="finalists__internship">Стажировка за границей в звездном мишленовском ресторане в 2026 г.</p>
					</div>
				</li>
				<li class="finalists__item" v-for="finalist in finalists" :key="finalist.id">
					<div class="finalists__holder-image">
						<div class="finalists__image">
							<img
								class="full-img"
								width="139"
								height="139"
								:src="finalist.survey.photo"
								alt="изображение"
							/>
						</div>
						<div class="finalists__label">Финалист</div>
					</div>
					<div class="finalists__content">
						<h3 class="finalists__name">{{ finalist.first_name }}</h3>
						<div class="finalists__info">
							<p class="finalists__city">{{ finalist.survey.city }}</p>
							<p class="finalists__restaurant">{{ finalist.survey.restaurant }}</p>
						</div>
						<p class="finalists__internship">Стажировка в ресторане SAVVA в 2026 г.</p>
					</div>
				</li>			                
			</ul>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.finalists {
	padding: 6rem 0 10rem;
	background: linear-gradient(180deg, #fff 0%, #fff9eb 100%);
    @media (max-width: vars.$x480) {
        padding: 4rem 0 10rem;
    }
}
.finalists__title {
	text-align: center;
	margin-bottom: 7rem;
    @media (max-width: vars.$x480) {
        margin-bottom: 3rem;
    }
}
.finalists__list {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	gap: 10rem;
    @media (max-width: vars.$t) {
        gap: 6rem;
    }
    @media (max-width: vars.$xx) {
        gap: 5rem;
    }
}
.finalists__item {
	width: 260px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	height: 100%;
	gap: 2rem;
    @media (max-width: vars.$x480) {
        gap: 2rem;
    }
}
.finalists__holder-image {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	height: 100%;
	// background-image: url("@/assets/img/stars.svg");
	// background-repeat: no-repeat;
	// background-position: center top; /* x y*/
	// background-size: contain; /* w h*/
}
.finalists__image {
	width: 100%;
	height: 100%;
	overflow: hidden;
	border-radius: 50%;
	img {
		aspect-ratio: 1/1;
	}
}
.finalists__label {
	position: absolute;
	bottom: -5%;
	border: 1px solid var(--red);
	border-radius: 2.4rem;
	padding: 0.5rem 1.2rem 0.7rem;
	background: var(--white);

	font-weight: 400;
	font-size: 1.6rem;
	line-height: 120%;
	text-align: center;
	color: var(--red);

	&.--red {
		background: var(--red);
		color: var(--white);
	}
}

.finalists__content {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
}
.finalists__name {
	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	text-align: center;
	color: var(--red);
    @media (max-width: vars.$x480) {
        font-size: 1.6rem;
        margin-bottom: 0.5rem;
    }
}
.finalists__info {
}
.finalists__city {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 120%;
	text-align: center;
	color: #000;
	@media (max-width: vars.$x480) {
        font-size: 1.4rem;
    }
}
.finalists__restaurant {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 120%;
	text-align: center;
	color: rgba(0, 0, 0, 0.6);
    @media (max-width: vars.$x480) {
        font-size: 1.4rem;
    }
}
.finalists__internship {
	
	font-weight: 400;
	font-size: 1.2rem;
	line-height: 140%;
	letter-spacing: 0%;
	text-align: center;
	color: var(--red);
}
</style>
